import React from 'react';

const AppFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer" role="contentinfo">
      <div className="app-footer__inner">
        <span className="app-footer__text">
          © {year} All rights reserved. for <a href="https://pianat.ai" className="app-footer__brand" target="_blank" rel="noopener noreferrer"><b>pianat.ai</b></a>
        </span>
      </div>
    </footer>
  );
};

export default AppFooter;
